import { render, staticRenderFns } from "./FavoritesSidebar.vue?vue&type=template&id=7961288c"
import script from "./FavoritesSidebar.vue?vue&type=script&lang=js"
export * from "./FavoritesSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeartIcon: require('/vercel/path0/components/icons/HeartIcon.vue').default,MenuCloseIcon: require('/vercel/path0/components/icons/MenuCloseIcon.vue').default,FavoritesProduct: require('/vercel/path0/components/shared/favorites/FavoritesProduct.vue').default})
